<template>
    <div class="row testament-btns">
        <div class="col-6">
            <button 
                class="btn btn-default" 
                :class="{active: this.$store.getters.getOldTSelected}"
                @click.prevent="toggleTestament" 
                >Old Testament</button>
        </div>
        <div class="col-6">
            <button 
                class="btn btn-default" 
                :class="{active: !this.$store.getters.getOldTSelected}"
                @click.prevent="toggleTestament" 
                >New Testament</button>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['oldTSelected'],
        methods: {
            toggleTestament(num) {
                this.$store.dispatch('updateOldTSelected');
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/TestamentButtons.vue